import React, { useState, useEffect, useRef, FC } from 'react';
import PropTypes, { InferProps } from 'prop-types';
import classNames from 'classnames/bind';

import styles from './RotatingText.module.pcss';

const cx = classNames.bind(styles);

const RotatingTextPropType = {
  textArray: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  customClass: PropTypes.string.isRequired
};

type RotatingTextProps = InferProps<typeof RotatingTextPropType>;

const updatedIndex = (cuuIndex: number, maxValue: number): number => {
  return cuuIndex === maxValue ? 0 : ++cuuIndex;
};

const RotatingText: FC<RotatingTextProps> = props => {
  const { textArray = [], customClass } = props;
  const [activeIndex, setActiveIndex] = useState(0);
  const [intervalId, setIntervalId] = useState(null);
  const maxIndex = textArray.length - 1;
  const handleIndexUpdate = useRef(() => {});
  const handleInterval = useRef(() => {});

  handleIndexUpdate.current = (): void => {
    const interval = setInterval(() => {
      setActiveIndex(index => {
        const newIndex = updatedIndex(index, maxIndex);
        return newIndex;
      });
    }, 2000);
    setIntervalId(interval);
  };

  handleInterval.current = (): void => {
    clearTimeout(intervalId);
  };
  useEffect(() => {
    handleIndexUpdate.current();
    return () => {
      handleInterval.current();
    };
  }, []);
  return (
    <div className={cx('textGroup')}>
      {textArray.map((text, index) => {
        return (
          // eslint-disable-next-line react/no-danger
          <div
            key={index}
            className={cx('noranlText', customClass, { fade: index === activeIndex })}
            dangerouslySetInnerHTML={{ __html: text }}
            aria-label={typeof text == 'string' ? text : ''}
          />
        );
      })}
    </div>
  );
};

RotatingText.propTypes = RotatingTextPropType;

export default RotatingText;
